"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_loupe_style_1 = __importDefault(require("./uicon.loupe.style"));
class UiconLoupe extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 17 17", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: [jsx_runtime_1.jsx("ellipse", { cx: "6.5", cy: "7.2", rx: "5.5", ry: "5.5", strokeWidth: "0.8", fill: "transparent" }, void 0),
                    jsx_runtime_1.jsx("line", { x1: "12.457", y1: "13.117", x2: "16.051", y2: "16.767", strokeWidth: "0.8" }, void 0),
                    jsx_runtime_1.jsx("path", { d: "M10.5,7.2H9.7c0-1.7-1.4-3.1-3.2-3.1V3.3C8.7,3.3,10.5,5,10.5,7.2z", strokeWidth: "0.025" }, void 0)] }), void 0));
        };
    }
}
UiconLoupe.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconLoupe.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_loupe_style_1.default)(UiconLoupe);
//# sourceMappingURL=uicon.loupe.js.map